import React from 'react';
import {
  TabContent, StoreFooter, getAddress, getBtnRadius, AWS_URL, FaHeart, MdSearch, MdShoppingCart, 
  MdFilterList, MdStore, MdList, MdHistory, MdExitToApp, MdAccountCircle, 
  MdLogin, MdHome, MdMenu, isDarkTheme, THEME_IMAGES
} from './ThemeLayoutHelpers';
export default function CleanLayout({ p }) {
  const theme = p.storeTheme || {};
  const text = p.storefrontText || {};
  const t = p.t || ((key) => key);
  const buttonRadius = getBtnRadius(theme);
  const cartCount = p.cart?.reduce((sum, item) => sum + (item.cartQuantity || 1), 0) || 0;
  const bannerUrl = p.getBannerUrl ? p.getBannerUrl() : null;
  const addressText = getAddress(p.storeInfo);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundColor: theme.backgroundColor || "#f9fafb",
        color: theme.textColor || "#1f2937",
        fontFamily: theme.fontFamily || "Inter",
      }}
    >
      <div
        className="py-3 px-4"
        style={{
          backgroundColor: theme.primaryColor || "#4f46e5",
          color: "#ffffff",
        }}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div>
            <div className="font-bold">{t("STORE.BECOME_A_DUKANBUDDY_USER")}</div>
            <div className="text-sm opacity-90">{t("STORE.MANAGE_YOUR_STORE")}</div>
          </div>
          <a
            href="https://app.dukanbuddy.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white px-4 py-2 font-medium hover:opacity-90 transition"
            style={{
              color: theme.primaryColor || "#4f46e5",
              borderRadius: buttonRadius,
            }}
          >
            {t("STORE.SIGN_UP_NOW")}
          </a>
        </div>
      </div>

      <nav className="w-full border-b shadow-sm bg-white sticky top-0 z-40">
        <div className="max-w-7xl mx-auto flex items-center py-3 px-4">
          <button
            onClick={() => p.setMobileMenuOpen(!p.mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg mr-2"
            style={{ color: theme.primaryColor || "#4f46e5" }}
          >
            <MdMenu size={24} />
          </button>

          <span
            className="text-2xl font-bold tracking-wide flex-1"
            style={{ color: theme.headingColor || "#111827" }}
          >
            {p.storeInfo?.businessName}
          </span>

          <div className="relative w-80 mr-4 hidden md:block">
            <input
              className="w-full py-2 pl-10 pr-4 rounded-lg placeholder-gray-500 focus:outline-none focus:ring-2 border"
              placeholder={text.searchProducts || "Search items..."}
              value={p.searchQuery}
              onChange={(e) => p.setSearchQuery(e.target.value)}
              style={{
                backgroundColor: "rgba(0,0,0,0.05)",
                borderColor: `${theme.primaryColor || "#4f46e5"}30`,
                color: theme.textColor || "#1f2937",
              }}
            />
            <MdSearch
              className="absolute left-3 top-2.5 text-lg"
              style={{ color: `${theme.primaryColor || "#4f46e5"}80` }}
            />
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:opacity-90 mr-2"
              onClick={() => p.setFilterPanelOpen(true)}
              style={{
                backgroundColor: theme.buttonColor || "#4f46e5",
                color: "#ffffff",
                borderRadius: buttonRadius,
              }}
            >
              <MdFilterList className="text-xl" />
              <span className="hidden sm:inline">{text.filter || "Filters"}</span>
            </button>

            <button
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:opacity-90 transition mr-2 relative"
              onClick={p.handleGoToWishlist}
              style={{
                backgroundColor: "transparent",
                border: `1px solid ${theme.primaryColor || "#4f46e5"}`,
                color: theme.primaryColor || "#4f46e5",
                borderRadius: buttonRadius,
              }}
              title={text.wishlist || "Wishlist"}
            >
              <FaHeart className="text-xl" />
              {p.wishlistLoading ? (
                <span className="absolute -top-2 -right-2">
                  <div
                    className="animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent"
                    style={{ color: theme.buttonColor || theme.primaryColor || "#4f46e5" }}
                  />
                </span>
              ) : p.wishlistCount > 0 ? (
                <span
                  className="absolute -top-2 -right-2 text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-md"
                  style={{
                    backgroundColor: theme.buttonColor || "#4f46e5",
                    color: "#ffffff",
                    border: "2px solid white",
                  }}
                >
                  {p.wishlistCount}
                </span>
              ) : null}
            </button>

            <button
              className="flex items-center gap-2 px-4 py-2 rounded-lg hover:opacity-90 transition font-semibold relative"
              onClick={p.handleOpenCart}
              style={{
                backgroundColor: theme.buttonColor || "#4f46e5",
                color: "#ffffff",
                borderRadius: buttonRadius,
              }}
            >
              <MdShoppingCart className="text-xl" />
              {cartCount > 0 && (
                <span
                  className="absolute -top-2 -right-2 text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-md"
                  style={{
                    backgroundColor: "#ffffff",
                    color: theme.buttonColor || "#4f46e5",
                    border: `2px solid ${theme.buttonColor || "#4f46e5"}`,
                  }}
                >
                  {cartCount}
                </span>
              )}
            </button>

            {p.userMenuElement}
          </div>

          <button
            onClick={p.handleOpenCart}
            className="md:hidden ml-2 p-2 relative"
            style={{ color: theme.primaryColor || "#4f46e5" }}
          >
            <MdShoppingCart size={24} />
            {cartCount > 0 && (
              <span
                className="absolute -top-1 -right-1 text-xs rounded-full h-5 w-5 flex items-center justify-center"
                style={{
                  backgroundColor: theme.buttonColor || "#4f46e5",
                  color: "#ffffff",
                }}
              >
                {cartCount}
              </span>
            )}
          </button>
        </div>

        {p.mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-3">
              <div className="relative mb-3">
                <input
                  className="w-full py-2 pl-10 pr-4 rounded-lg placeholder-gray-500 focus:outline-none focus:ring-2 border"
                  placeholder={text.searchProducts || "Search items..."}
                  value={p.searchQuery}
                  onChange={(e) => p.setSearchQuery(e.target.value)}
                  style={{
                    backgroundColor: "rgba(0,0,0,0.05)",
                    borderColor: `${theme.primaryColor || "#4f46e5"}30`,
                    color: theme.textColor || "#1f2937",
                  }}
                />
                <MdSearch
                  className="absolute left-3 top-2.5 text-lg"
                  style={{ color: `${theme.primaryColor || "#4f46e5"}80` }}
                />
              </div>

              <div className="flex flex-col gap-2">
                <button
                  className="flex items-center gap-2 px-4 py-2 rounded-lg"
                  onClick={() => {
                    p.setFilterPanelOpen(true);
                    p.setMobileMenuOpen(false);
                  }}
                  style={{
                    backgroundColor: theme.buttonColor || "#4f46e5",
                    color: "#ffffff",
                    borderRadius: buttonRadius,
                  }}
                >
                  <MdFilterList className="text-xl" />
                  {text.filter || "Filters"}
                </button>

                <button
                  className="flex items-center gap-2 px-4 py-2 rounded-lg relative"
                  onClick={() => {
                    p.handleGoToWishlist();
                    p.setMobileMenuOpen(false);
                  }}
                  style={{
                    backgroundColor: "transparent",
                    border: `1px solid ${theme.primaryColor || "#4f46e5"}`,
                    color: theme.primaryColor || "#4f46e5",
                  }}
                >
                  <FaHeart className="text-xl" />
                  <span className="flex-1 text-left">{text.wishlist || "Wishlist"}</span>
                  {p.wishlistLoading ? (
                    <div
                      className="animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent"
                      style={{ color: theme.buttonColor || "#4f46e5" }}
                    />
                  ) : p.wishlistCount > 0 ? (
                    <span
                      className="text-xs rounded-full h-5 w-5 flex items-center justify-center"
                      style={{
                        backgroundColor: theme.buttonColor || "#4f46e5",
                        color: "#ffffff",
                      }}
                    >
                      {p.wishlistCount}
                    </span>
                  ) : null}
                </button>

                {!p.userProfile ? (
                  <button
                    className="flex items-center gap-2 px-4 py-2 rounded-lg border"
                    onClick={() => {
                      p.handleOpenLogin();
                      p.setMobileMenuOpen(false);
                    }}
                    style={{
                      borderColor: theme.primaryColor || "#4f46e5",
                      color: theme.primaryColor || "#4f46e5",
                    }}
                  >
                    <MdLogin className="text-xl" />
                    {t("STORE.LOGIN") || "Login"}
                  </button>
                ) : (
                  <div className="border-t pt-2">
                    {(() => {
                      const dark = isDarkTheme(theme);
                      const hoverClass = dark ? "hover:bg-gray-800" : "hover:bg-gray-50";
                      const textCol = theme.textColor || (dark ? "#f3f4f6" : "#1f2937");
                      
                      return (
                        <>
                          <div className="flex items-center gap-2 px-4 py-2">
                            <div
                              className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center"
                              style={{ color: theme.primaryColor || "#4f46e5" }}
                            >
                              {p.userProfile?.name
                                ? p.userProfile.name.charAt(0).toUpperCase()
                                : "G"}
                            </div>
                            <div>
                              <div className="font-medium" style={{ color: textCol }}>{p.userProfile?.name || t("ONLINE_STORE.GUEST")}</div>
                              <div className="text-xs text-gray-500" style={{ color: textCol + "80" }}>{p.userProfile?.customer_mobile || t("ONLINE_STORE.NO_PHONE_NO")}</div>
                            </div>
                          </div>
                          <button
                            className={`w-full text-left px-4 py-2 ${hoverClass} flex items-center gap-2`}
                            onClick={() => {
                              p.handleViewProfile();
                              p.setMobileMenuOpen(false);
                            }}
                            style={{ color: textCol }}
                          >
                            <MdAccountCircle />
                            {t("ONLINE_STORE.PROFILE_DETAILS") || "Profile"}
                          </button>
                          <button
                            className={`w-full text-left px-4 py-2 ${hoverClass} flex items-center gap-2`}
                            onClick={() => {
                              p.handleViewOrders();
                              p.setMobileMenuOpen(false);
                            }}
                            style={{ color: textCol }}
                          >
                            <MdHistory />
                            {t("ONLINE_STORE.ORDER_HISTORY") || "Orders"}
                          </button>
                          <button
                            className={`w-full text-left px-4 py-2 ${hoverClass} flex items-center gap-2`}
                            onClick={() => {
                              p.handleBackToLanding();
                              p.setMobileMenuOpen(false);
                            }}
                            style={{ color: textCol }}
                          >
                            <MdHome />
                            {t("STORE.LANDING") || "Landing Page"}
                          </button>
                          <button
                            className={`w-full text-left px-4 py-2 ${hoverClass} flex items-center gap-2 text-red-600`}
                            onClick={() => {
                              p.handleLogout();
                              p.setMobileMenuOpen(false);
                            }}
                          >
                            <MdExitToApp />
                            {t("ONLINE_STORE.LOGOUT") || "Logout"}
                          </button>
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>

      <div className="relative">
        <div className="h-80 w-full relative overflow-hidden">
          {p.storeBanner?.type === "color" ? (
            <div className="h-full w-full" style={{ backgroundColor: p.storeBanner.color || theme.primaryColor || "#4f46e5" }} />
          ) : (
            <img
              src={bannerUrl || THEME_IMAGES.dawn}
              alt="Store Cover"
              className="h-full w-full object-cover object-center"
            />
          )}

          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />

          {p.storeBanner?.type === "color" && (
            <div className="absolute inset-0 opacity-10">
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: "linear-gradient(45deg, transparent 48%, rgba(255,255,255,0.1) 50%, transparent 52%)",
                  backgroundSize: "40px 40px",
                }}
              />
            </div>
          )}
        </div>

        <div className="absolute bottom-4 left-4 flex items-center gap-4">
          <div className="h-20 w-20 rounded-full border-4 border-white bg-white shadow-lg overflow-hidden">
            {p.storeInfo?.businesslogo ? (
              <img src={AWS_URL + p.storeInfo.businesslogo} alt="Store logo" className="h-full w-full object-cover" />
            ) : (
              <div className="h-full w-full flex items-center justify-center text-lg font-bold text-slate-500">
                {p.storeInfo?.businessName?.charAt(0)?.toUpperCase() || "S"}
              </div>
            )}
          </div>
          <div>
            <h1 className="text-xl font-bold text-white drop-shadow-lg" style={{ fontFamily: theme.fontFamily || "Inter" }}>
              {p.storeInfo?.businessName}
            </h1>
            <p className="text-sm text-white/90 drop-shadow-lg">{addressText}</p>
          </div>
        </div>
      </div>

      <div className="mt-8 mb-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex border-b border-gray-200 overflow-x-auto">
            {[
              ["details", text.business || text.about || "Business Details", <MdStore key="details" className="text-xl" />],
              ["products", text.products || "Products", <MdList key="products" className="text-xl" />],
              ["services", text.services || "Services", <MdList key="services" className="text-xl" />],
            ].map(([tabKey, label, icon]) => (
              <button
                key={tabKey}
                className={`px-6 py-3 font-medium flex items-center gap-2 transition-all duration-200 whitespace-nowrap ${
                  p.activeTab === tabKey ? "border-b-2" : "opacity-70 hover:opacity-100"
                }`}
                onClick={() => p.setActiveTab(tabKey)}
                style={{
                  borderBottomColor: p.activeTab === tabKey ? theme.primaryColor || "#4f46e5" : "transparent",
                  color: p.activeTab === tabKey ? theme.primaryColor || "#4f46e5" : (theme.textColor || (isDarkTheme(theme) ? "#f3f4f6" : "#4b5563")),
                }}
              >
                {icon}
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex-1 pb-10">
        <div className="max-w-7xl mx-auto px-4">
          <TabContent p={p} />
        </div>
      </div>

      <StoreFooter p={p} />
    </div>
  );
}